var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{staticClass:"py-8 mb-8",attrs:{"icon":"exclamation-triangle","msg-title":"We couldn't load your account data","msg-text":"Refresh the page or chat to us and we'll look into it for you","noButton":true}})}
var staticRenderFns = []

export { render, staticRenderFns }